import { BUSINESS_API_PREFIX, BUSINESS_ACCOUNTS_AJAX_PREFIX } from '../common/common-urls';

export const BUSINESS_POTENTIAL = `${BUSINESS_API_PREFIX}/potential`;
export const BUSINESS_PROFILE = `${BUSINESS_API_PREFIX}/business_info`;
export const ORGANIZATION_PROFILE = `${BUSINESS_API_PREFIX}/organization_profile`;
export const BUSINESS_PROFILE_CONFIG = `${BUSINESS_PROFILE}/config`;
export const USER_REGISTRATION_CONTEXT = `${BUSINESS_API_PREFIX}/registration/context`;
export const BUSINESS_USER_ACTIVITIES = `${BUSINESS_API_PREFIX}/user_activities`;
export const CREATE_ORGANIZATION = `${BUSINESS_API_PREFIX}/organization`;
export const UPDATE_USER_FULL_NAME = `/business_onboarding/ajax/user/update_fullname`;
export const MIGRATE_ACCOUNT = `${BUSINESS_ACCOUNTS_AJAX_PREFIX}/members/migrate`;
export const IMPORT_BUSINESS_INFO = `${BUSINESS_API_PREFIX}/business_info/import`;
export const ACCEPT_INVITATION = `${BUSINESS_API_PREFIX}/invitation/accept`;
